/**
 * Tashqi to'lov sahifasiga o'tish — host/qurilmaga moslashgan.
 *
 * Bemor bolalar (ChildDetailPage) va Maktab bozori (BazaarView) bir xil
 * redirect logikasini ishlatadi — shuning uchun shu yerda markazlashtirilgan.
 */

import { IS_CLICK_DOMAIN } from "@/lib/env";

/** Telegram WebApp ning bizga kerakli minimal qismi */
interface TgLinkOpener {
  openLink?: (url: string, options?: { try_browser?: boolean }) => void;
}

/**
 * Mini app ning joriy origini — to'lovdan keyin qaytish manzili shundan quriladi.
 *
 * MUHIM: ilgari barcha return URL larda `click.insonuchun.uz` qattiq yozilgan edi.
 * Natijada Zoomrad / Paynet / AnorBank ichida to'lov qilgan foydalanuvchi Click
 * domeniga tushib qolardi — u yerda uning sessiyasi yo'q (Click `web-session`
 * cookie si boshqa host da yozilmaydi) va "Tizimga kirishda xatolik" ko'rinardi.
 * Endi har bir host o'z domeniga qaytadi: zoomrad → zoomrad, paynet → paynet.
 */
export function getMiniAppOrigin(): string {
  if (typeof window === "undefined") return "https://insonuchun.uz";
  return window.location.origin;
}

/** iOS WebView (iPhone/iPad/iPadOS) ni aniqlaydi */
export function isIOSWebView(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const iosUa = /iPad|iPhone|iPod/.test(ua);
  const ipadOs = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return iosUa || ipadOs;
}

/**
 * To'lov URL ini ochadi — provayder emas, KONTEKST hal qiladi.
 *
 *  1) Click super-app ichida (click.insonuchun.uz) → same-tab redirect.
 *     Click webview my.click.uz ni o'zi nativ ochadi.
 *  2) Telegram bot ichida (`tg.openLink` mavjud) → tashqi (system) brauzerga
 *     uzatamiz. MUHIM: Telegram'ning ichki brauzeri Android App Link /
 *     iOS Universal Link larni ushlab qolib, my.click.uz / checkout.paycom.uz
 *     ni o'z ichida ochadi — natijada Click/Payme ILOVASI ochilmaydi.
 *     `try_browser:true` esa URL ni Chrome/Safari ga beradi, u esa App Link
 *     orqali tegishli ilovani ochadi (Payme allaqachon shunday ishlaydi,
 *     endi Click ham bir xil yo'l bilan ishlaydi).
 *  3) Oddiy web (Telegram emas, Click domeni emas) → same-tab redirect.
 *
 * Eslatma: bu yerda `providerId` bo'yicha shart YO'Q — ilgari `click` alohida
 * `window.location.href` ga majburlangan va Telegram bot ichida Click ilovasi
 * ochilmay qolgan (Telegram brauzerida ochilavergan).
 */
export function openExternalPaymentLink(
  url: string,
  _providerId: string,
  tg?: TgLinkOpener | null
): void {
  // 1) Click super-app ichida — nativ same-tab redirect.
  if (IS_CLICK_DOMAIN) {
    window.location.href = url;
    return;
  }

  // 2) Telegram bot ichida — tashqi brauzerga uzatamiz (App Link → ilova).
  if (tg?.openLink) {
    try {
      tg.openLink(url, { try_browser: true });
      return;
    } catch {
      // pastdagi fallback ishlaydi
    }
  }

  // 3) Oddiy web — same-tab redirect.
  window.location.href = url;
}
